import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { Accordion } from 'react-bootstrap';
import ReactDOMServer from 'react-dom/server';
import axios from 'axios';
import { AppRemixIcon } from '@/layout/AppComponents';
import routes from './moduleComsaEnvironmentalRoutes';
import Sidebar from '../../../layout/Sidebar/Sidebar';
import Translator from '../../../layout/components/helpers/Translator';
import AppLink from '../../../routing/helpers/AppLink';
import { axiosPath } from '@/routing/helpers/router';
import errorHandler from '@/layout/components/error/ErrorHandler';

export default function ModuleComsaEnvironmentalSideBarReports({ activeRoute }) {
  const { moduleBridgeHex, subModuleBridgeHex, plantHex } = useParams();
  const dispatch = useDispatch();
  const global = useSelector((state) => state.global);
  const moduleData = useSelector((state) => state.currentPage?.moduleData);

  
  const handleReport = () => axios
    .post(
        axiosPath('api_r_user_module_comsaEnvironmental_getXlsReport'),
        {
            moduleBridgeHex,
            subModuleBridgeHex,
            plantHex,
            section: moduleData?.selectedSection?.name,
        }
    )
    .then(({ data }) => (window.location = data))
    .catch((e) => dispatch(errorHandler(e)))


  return (
    <Sidebar>
      <Accordion>
        <ul>
          {routes.map(
            (r) =>
              moduleData?.sidebarElements.includes(r.type) && (
                <li
                  key={r.type}
                  className={`${activeRoute === r.routeName ? 'active' : ''}`}
                >
                  <AppLink
                    path={r.routeName}
                    params={{
                      moduleBridgeHex,
                      subModuleBridgeHex,
                      plantHex,
                    }}
                    className="p-0"
                  >
                    <span
                      className="sidebar-element"
                      title={ReactDOMServer.renderToString(
                        <Translator
                          file="module-comsaEnvironmental"
                          name={r.title}
                        />
                      )}
                    >
                      <AppRemixIcon icon={r.icon} className="sidebar-icon" />
                      <span className="sb-title">
                        <Translator
                          file="module-comsaEnvironmental"
                          name={r.title}
                        />
                      </span>
                    </span>
                  </AppLink>
                </li>
              )
          )}
          <li>
            <span className="p-0" onClick={handleReport}>
              <span
                className="sidebar-element"
                title={ReactDOMServer.renderToString(
                  <Translator
                    file="module-comsaReports"
                    name="download.report"
                  />
                )}
              >
                <AppRemixIcon icon="file-excel-2" className="sidebar-icon" />
                <span className="sb-title">
                  <Translator
                    file="module-comsaReports"
                    name="download.report"
                  />
                </span>
              </span>
            </span>
          </li>
        </ul>
      </Accordion>
    </Sidebar>
  );
}
